import {getIcon, initMap} from "./_maps-common.js";

let map;
let markers = {};
let tooltips = {};
let infowindow;
let bounds;

window.createMap = function (locations, shopId) {
    [bounds, infowindow, map] = initMap();

    for (let i in locations) {
        addMarker(locations[i]);
    }

    if (shopId) {
        selectMarker(markers[shopId], tooltips[shopId], 1000);
    }
    else {
        resetMapZoom();
    }
};

window.resetMap = function () {
    resetMapZoom();
    closeInfoWindow();
};

function resetMapZoom() {
    map.fitBounds(bounds);
}

function closeInfoWindow() {
    if (infowindow) {
        infowindow.close();
    }
}

function addMarker(location) {
    markers[location.id] = new google.maps.Marker({
        position: new google.maps.LatLng(location.lat, location.lng),
        title: location.title,
        map: map,
        icon: getIcon()
    });

    tooltips[location.id] = location.tooltip.replace('{openNow}', openNow());

    let marker = markers[location.id];
    let tooltip = tooltips[location.id];

    bounds.extend(marker.position);

    google.maps.event.addListener(marker, 'click', function () {
        selectMarker(marker, tooltip);
    });

}

function selectMarker(marker, tooltip, delay) {
    closeInfoWindow();

    map.setZoom(16);
    map.setCenter(marker.getPosition());

    setTimeout(function () {
        infowindow.setContent(tooltip);
        infowindow.open(map, marker);
    }, delay || 0);
}

function openNow() {
    return isOpenNow() ?
        '<strong class="text-success">Ouvert maintenant</strong>' :
        '<strong class="text-danger">Magasin Fermé</strong>';
}

// Tu - Fri 9:00 - 18:00
function isOpenNow() {
    let format = 'hh:mm:ss';
    let time = moment(new Date(), format);
    let day = (new Date()).getDay();
    let beforeTime;
    let afterTime;

    if (day < 2 || day > 6) {
        return false;
    }

    // Sa
    beforeTime = moment('09:00:00', format);
    afterTime = moment('17:30:00', format);

    // Tu - Fri
    if (day < 6) {
        beforeTime = moment('09:30:00', format);
        afterTime = moment('18:00:00', format);
    }

    return time.isBetween(beforeTime, afterTime);
}